import { render, staticRenderFns } from "./PPPK.vue?vue&type=template&id=c6ce4fa4"
import script from "./PPPK.vue?vue&type=script&lang=js"
export * from "./PPPK.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports